import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '@/views/Home.vue'
import informationList from '@/views/informationList.vue'
import informationDetail from '@/views/informationDetail.vue'
import mobileHome from '@/views/mobile/Home.vue'
import mobileinformationList from '@/views/mobile/informationList.vue'
import mobileinformationPoster from '@/views/mobile/informationPoster.vue'
import mobileinformationDetail from '@/views/mobile/informationDetail.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
  },
  {
    path: '/informationList',
    name: 'informationList',
    component: informationList,
  },
  {
    path: '/informationDetail',
    name: 'informationDetail',
    component: informationDetail,
  },
  {
    path: '/mobile/',
    name: 'mobileHome',
    component: mobileHome,
  },
  {
    path: '/mobile/informationList',
    name: 'mobileinformationList',
    component: mobileinformationList,
  },
  {
    path: '/mobile/informationPoster',
    name: 'mobileinformationPoster',
    component: mobileinformationPoster,
  },
  {
    path: '/mobile/informationDetail',
    name: 'mobileinformationDetail',
    component: mobileinformationDetail,
  },
]

const router = new VueRouter({
  // mode: 'hash',
  mode: 'history',
  // base:"/ent/",
  routes,
})

export default router
